module.exports = __webpack_public_path__ + "static/media/more-dark.80fd4420.svg";